export default class AfpUser{
	public actualizado: string = "";
	public aptO1: string = ""; 
	public aptO2: string = ""; 
	public beeper: string = ""; 
	public cedula: string = ""; 
	public celular: string = ""; 
	public ciabeep: string = ""; 
	public ciacel: string = ""; 
	public ciudad1: string = "";
	public ciudad2: string = "";
	public codciudaD1: string = "";
	public codciudaD2: string = "";
	public codebeeper: string = "";
	public codecelular: string = "";
	public codefax: string = "";
	public codeotrotelefono: string = "";
	public codetelcasa: string = "";
	public codeteltrabajo: string = "";
	public codpersona: string = "";
	public codsectoR1: string = "";
	public codsectoR2: string = "";
	public codusuario: string = "";
	public controltransferencia: string = "";
	public diaaporte: string = "";
	public domiciliO1: string = "";
	public domiciliO2: string = "";
	public edificiO1: string = "";
	public edificiO2: string = "";
	public emailservidor: string = "";
	public emailusuario: string = "";
	public estadocivil: string = "";
	public fax: string = "";
	public fechaactualizado: string = "";
	public fechanac: string = ""; 
	public idnss: string = ""; 
	public indusrcolectivo: string = "";
	public l1: string = "";
	public numerO1: string = "";
	public numerO2: string = "";
	public otrotelefono: string = "";
	public paiS1: string = "";
	public paiS2: string = "";
	public otro1: string = "";
	public otro2: string = "";
	public otra1: string = "";
	public otra2: string = "";
	public password: string = "";
	public primerapellido: string = "";
	public primernombre: string = "";
	public razonsocial: string = "";
	public sector1: string = "";
	public sector2: string = "";
	public segundoapellido: string = "";
	public segundonombre: string = "";
	public telcasa: string = "";
	public teltrabajo: string = "";
	public tipousuario: string = "";
	public contacts: Array<AfpUserContact> = [];
}

export class AfpUserContact{
	public cedulacontacto: string = ""; 
	public direccioncontacto: string = ""; 
	public emailcontacto: string = ""; 
	public esmenor: string = ""; 
	public idsec: string = ""; 
	public nombrecontacto: string = ""; 
	public numemision: string = ""; 
	public numlote: string = ""; 
	public parentescocontacto: string = "";
	public periodo: string = "";
	public seqcorte: string = "";
	public telefonocontacto: string = "";
	public isExpanded: boolean = false;
}